import items from '../../api/project'

const initialState = {
  projects: items,
}

const project = (state = initialState, action) => {
  return state
}

export default project
